import React, { Component, useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import ComponentAttendanceProMobile from "./ComponentAttendanceProMobile";

const ComponentAttendancePro = () => {
  return (
    <>
      <BrowserView>
        <ComponentAttendanceProMobile></ComponentAttendanceProMobile>
      </BrowserView>
      <MobileView>
        <ComponentAttendanceProMobile></ComponentAttendanceProMobile>
      </MobileView>
    </>
  );
};

export default ComponentAttendancePro;
